import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const AppAreaStyled = styled.div`
  width: 100%;
  @media (min-width: 950px) {
    height: ${({ scroll }) => {
      return !scroll ? "calc(100vh - 50px - 22px)" : "auto";
    }};
  }
`;
const FullAreaStyled = styled.div`
  width: 100%;
  height: 100%;
`;

export const AppArea = props => {
  const { children, ...otherProps } = props;
  return <AppAreaStyled {...otherProps}>{children}</AppAreaStyled>;
};

export const FullArea = props => {
  const { children, ...otherProps } = props;
  return (
    <FullAreaStyled className="full-area" {...otherProps}>
      {children}
    </FullAreaStyled>
  );
};



// WEBPACK FOOTER //
// ./src/components/Utils.js